import { useRef } from "react";
import { PAGE_TOPSET } from "~/constants";
import { useStuck } from "~/hooks/stuck";
import type { ProductCategory } from "~/types";
import { getCategoryDomId } from "~/utils/category";
import { Box } from "../Box/Box";
import { getStickyHeaderHeight } from "../utils/stuck";
import { CategoryBar } from "./CategoryBar";

export function SearchCategoryBar({
  currentCategoryId,
  filteredMenu,
  searchValue,
  setSearchValue,
  loading,
}: {
  currentCategoryId: string;
  filteredMenu: ProductCategory[];
  searchValue: string;
  setSearchValue: (value: string) => void;
  loading: boolean;
}) {
  const ref = useRef<HTMLElement>(null);

  const stuck = useStuck(ref, { desktopStuck: true });

  return (
    <Box
      ref={ref}
      background="jets-beige"
      paddingY="4"
      display="flex"
      justifyContent="center"
      width="full"
      style={{
        boxShadow: stuck ? "0px 4px 4px rgba(0, 0, 0, 0.1)" : undefined,
        top: getStickyHeaderHeight(),
        zIndex: 4,
      }}
      paddingX={["5", "none"]}
      position="sticky"
    >
      <Box
        width="full"
        style={{
          maxWidth: "450px", // TODO: This shouldn't be hardcoded, but is in a number of other places for desktop maxWidth and needs to be revisited
        }}
      >
        <CategoryBar
          menu={filteredMenu}
          selectedCategory={
            filteredMenu.find(
              (cat) => getCategoryDomId(cat.id) === currentCategoryId,
            ) || { title: "Choose menu category", id: "" }
          }
          onSelectCategory={(category) => {
            const el = document.getElementById(getCategoryDomId(category.id));

            if (el) {
              window.scrollTo({
                top: el.offsetTop - PAGE_TOPSET,
              });

              // Set the tab focus to the element we just scrolled to
              // We need to add a small delay to ensure the scroll completes first
              setTimeout(() => {
                // Make the element focusable
                if (!el.hasAttribute("tabindex")) {
                  el.setAttribute("tabindex", "-1");
                }

                // Focus the element
                el.focus();

                // Set aria-live to ensure screen readers announce the new content
                el.setAttribute("aria-live", "polite");
              }, 100);
            }
          }}
          searchValue={searchValue}
          onSearch={setSearchValue}
          loading={loading}
        />
      </Box>
    </Box>
  );
}
